import React, { useState } from 'react';
import { connect } from 'react-redux';
import { ModalPortal } from 'AppSrc/core/components/portals/modal-portal';
import PropTypes from 'prop-types';
import { VFDropdownBase } from 'AppSrc/core/components/forms/form-base-components/v-f-dropdown-base';
import { changeStatusReasonForEditCrqId } from 'AppSrc/core/actions/actions-edit-form';
import {
  getCancelationReasonDisplayOptions,
  getDefaultCancelationReason,
} from 'AppSrc/core/crq/crq-status-reasons';


const CancelationReasonDropdown = ({
  network,
  selectedValue,
  onChange,
}) => {
  const displayOptions = getCancelationReasonDisplayOptions(network);
  return (
    <VFDropdownBase
      displayOptions={displayOptions}
      updateValue={onChange}
      fieldTitle="Please enter reason for cancellation"
      name="cancelationReason"
      value={selectedValue}
      // placeholder="Please select"
    />
  );
};

CancelationReasonDropdown.propTypes = {
  network: PropTypes.string,
  selectedValue: PropTypes.string,
  onChange: PropTypes.func,
};

const CancelCrqModalDisplay = ({
  closeModal,
  rejectToPrevStatus,
  cancelCrq,
  statusReason,
  network,
}) => {
  const STATUS_REASON = statusReason; // Extracting statusReason
  const defaultReason = (STATUS_REASON === 'PostponedCRQ' || STATUS_REASON === '30300') ? null : getDefaultCancelationReason(network);
  const [selectedReason, setSelectedReason] = useState(defaultReason);
  const readyToSubmit = Boolean(selectedReason);
  const handleCancelCrq = () => {
    cancelCrq(selectedReason);
    rejectToPrevStatus(network);
    closeModal();
  };

  return (
    <ModalPortal>
      <div
        className="v-f-modal-section cancel-crq-modal"
      >
        <div className="v-f-modal-shadow" />
        <div className="v-f-modal-inner">
          <div className="cancel-crq-modal-content">
            <h3>
              Are you sure you want to cancel this CRQ
            </h3>
            <CancelationReasonDropdown
              network={network}
              selectedValue={selectedReason}
              onChange={setSelectedReason}
            />
            <div className="form-modal-options form-modal-options-space-maker" />
            <div className="form-modal-options">
              <div className="side-left">
                <button
                  type="button"
                  className="cancel-button"
                  onClick={closeModal}
                >
                  Back
                </button>
              </div>
              <div className="side-right">
                <button
                  type="button"
                  className={`save-button save-button-${readyToSubmit ? 'ready' : 'not-ready'}`}
                  disabled={!readyToSubmit}
                  onClick={handleCancelCrq}
                >
                  Cancel CRQ
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ModalPortal>
  );
};

CancelCrqModalDisplay.propTypes = {
  closeModal: PropTypes.func,
  rejectToPrevStatus: PropTypes.func,
  network: PropTypes.string,
  cancelCrq: PropTypes.func,
  statusReason: PropTypes.string,
};




const mapDispatchToProps = (dispatch, ownProps) => ({
  cancelCrq(statusReason) {
    const {
      crqId,
    } = ownProps;
    // clear the status_reason when rejecting from peer review
    dispatch(changeStatusReasonForEditCrqId({
      crqId,
      statusReason: statusReason ? statusReason : null,
    }));
  },
});

const CancelCrqModal = connect(
  null,
  mapDispatchToProps,
)(CancelCrqModalDisplay);





export { CancelCrqModal };
